export default __webpack_public_path__ + "static/media/msn-logo.ff8e3a4e.svg";